import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ShowMoreOverlay from './showMoreOverlay'

class ShowMore extends React.Component {
  static defaultProps = {
    showMoreLabel: 'Show more',
    showLessLabel: 'Show less',
    linesNumber: 2,
    lineHeight: 1.5,
    lineSizeUnit: 'em',
    isExpanded: false,
    linkClassName: '',
    linkExpandedClassName: ''
  }

  static propTypes = {
    lineHeight: PropTypes.number,
    lineSizeUnit: PropTypes.string,
    linesNumber: PropTypes.number,
    showMoreLabel: PropTypes.string,
    showLessLabel: PropTypes.string,
    linkClassName: PropTypes.string,
    linkExpandedClassName: PropTypes.string,
    isExpanded: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      isExpanded: props.isExpanded,
      isOverflown: props.isOverflown
    }

    this.onShowMoreOrLess = this.onShowMoreOrLess.bind(this)
  }

  label() {
    return this.state.isExpanded
      ? this.props.showLessLabel
      : this.props.showMoreLabel
  }

  onShowMoreOrLess(event) {
    event.preventDefault()

    this.setState({
      isExpanded: !this.state.isExpanded
    })
  }

  setOverlayDomRef(el) {
    this.overlayDomRef = el
  }

  componentDidMount() {
    this.updateOverflow()
  }

  componentDidUpdate() {
    this.updateOverflow()
  }

  updateOverflow() {
    if (this.checkOverflow() !== this.state.isOverflown) {
      this.setState({ isOverflown: !this.state.isOverflown })
    }
  }

  checkOverflow() {
    const SCROLL_HEIGHT_THRESHOLD = 3
    if (!this.overlayDomRef) return true
    return (
      this.overlayDomRef.scrollHeight - this.overlayDomRef.clientHeight >
      SCROLL_HEIGHT_THRESHOLD
    )
  }

  displayLink() {
    const { isExpanded, isOverflown } = this.state
    const { linkClassName, linkExpandedClassName } = this.props
    const linkClassNames = classnames(linkClassName, {
      [linkExpandedClassName]: isExpanded
    })

    if (isExpanded || isOverflown) {
      return (
        <a href="#" onClick={this.onShowMoreOrLess} className={linkClassNames}>
          {this.label()}
        </a>
      )
    }
  }

  render() {
    const { isExpanded } = this.state
    const { lineHeight, linesNumber, lineSizeUnit, children } = this.props
    return (
      <div>
        <ShowMoreOverlay
          linesNumber={linesNumber}
          lineHeight={lineHeight}
          lineSizeUnit={lineSizeUnit}
          isExpanded={isExpanded}
          setDomRef={this.setOverlayDomRef.bind(this)}
        >
          {children}
        </ShowMoreOverlay>
        {this.displayLink()}
      </div>
    )
  }
}

export default ShowMore
